// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.test_result_import_status_enum */
var TestResultImportStatusEnum;
(function (TestResultImportStatusEnum) {
    TestResultImportStatusEnum["NEEDS_SHEET"] = "NEEDS_SHEET";
    TestResultImportStatusEnum["UPLOADED"] = "UPLOADED";
    TestResultImportStatusEnum["EXTRACTING"] = "EXTRACTING";
    TestResultImportStatusEnum["REVIEW"] = "REVIEW";
    TestResultImportStatusEnum["COMMITTED"] = "COMMITTED";
    TestResultImportStatusEnum["FAILED"] = "FAILED";
})(TestResultImportStatusEnum || (TestResultImportStatusEnum = {}));
;
export default TestResultImportStatusEnum;
/** Zod schema for test_result_import_status_enum */
export const testResultImportStatusEnum = z.nativeEnum(TestResultImportStatusEnum);
//# sourceMappingURL=TestResultImportStatusEnum.js.map